export default {
  state: {
    activeMenu: null
  },
  mutations: {
    setActiveMenu(state, activeMenu) {
      state.activeMenu = activeMenu;
    }
  },
  getters: {
    getActiveMenu(state) {
      return state.activeMenu.children ? state.activeMenu.children : [];
    }
  },
  actions: {}
};